import all from '@/components/chart/all'
import money from '@/components/chart/money'
import share from '@/components/chart/share'
let routes = [
    {
      path: '/chart',
      name: 'chart',
      component: all,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/moneyChart',
      name: 'moneyChart',
      component: money,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/share',
      name: 'share',
      component: share,
      meta: {
        requiresAuth: true
      }
    }
  ]
export default { routes }


// WEBPACK FOOTER //
// ./src/router/chart.js